





























































import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {PreparationOrderProduct} from "@/model/preparation/PreparationOrderProduct";
import {PreparationType} from "@/model/preparation/PreparationType";
import ChangeQuantity from "@/components/orders/ChangeQuantity.vue";
import humanReadableQuantity from '@/filters/QuantityFormatter';
import {ModifiedQuantity} from "@/model/order/ModifiedQuantity";
import {Quantity} from "@/model/Quantity";

@Component({
  components: {ChangeQuantity},
  filters: {humanReadableQuantity}
})
export default class PreparationOrderProductLine extends Vue {

  @Prop({default: null}) product: PreparationOrderProduct;
  @Prop({default: false}) isEditing: boolean;
  @Prop({default: false}) isPrepared: boolean;

  public modifiedQuantity: ModifiedQuantity = new ModifiedQuantity();
  private debounceTimer: any = null;
  private isInitializing: boolean = true;

  beforeDestroy(): void {
    clearTimeout(this.debounceTimer);
  }

  mounted() {
    this.modifiedQuantity.quantity = new Quantity();
    this.modifiedQuantity.quantity.value = this.product?.preparedQuantity?.value ?? this.product?.quantity?.value;
    this.modifiedQuantity.cug = this.product?.cug;

    this.$nextTick(() => {
      this.isInitializing = false;
    });
  }

  @Watch('modifiedQuantity.quantity.value')
  onQuantityChanged(): void {
    if (this.isInitializing) {
      return;
    }

    clearTimeout(this.debounceTimer);
    this.debounceTimer = setTimeout(() => {
      this.$emit('onPreparedQuantityChange', this.product, this.modifiedQuantity.quantity);
    }, 500);
  }


  get isModifiedQuantityInferior(): boolean {
    if (!this.hasProductQuantity) {
      return false;
    }

    if (!this.hasModifiedQuantity) {
      return false;
    }

    return this.modifiedQuantity.quantity.value < this.product.quantity.value;
  }

  get hasProductQuantity(): boolean {
    return this.product != null && this.product.quantity != null;
  }

  get hasModifiedQuantity(): boolean {
    return this.modifiedQuantity != null && this.modifiedQuantity.quantity != null;
  }

  get isFabProduct(): boolean {
    return this.product?.preparationType === PreparationType.FAB;
  }

  get preparationTypeLabel(): string {
    return this.isFabProduct ? PreparationType.FAB : "Négoce";
  }

  get processedQuantity(): Quantity {
    if (this.product.processedQuantity != null) {
      return this.product.processedQuantity;
    }

    return new Quantity(0);
  }

  get processedMaxQuantity(): number {
    return this.isFabProduct ? this.product.processedQuantity?.value : this.product.quantity?.value;
  }

  get thumbnail(): string {
    return this.product?.thumbnail ?? require('@/assets/product-settings.svg');
  }

  get hasOrigin(): boolean {
    return this.product?.origin != null && this.product?.origin !== '';
  }

  get hasQuantityPrepared(): boolean {
    return this.product?.preparedQuantity != null;
  }

  get hasMissingQuantity(): boolean {
    return this.product?.quantity?.value !== this.product?.preparedQuantity?.value;
  }

  get isPreparedQuantityMissing(): boolean {
    return this.hasProductQuantity && (this.product.preparedQuantity?.value ?? 0) < this.product.quantity.value;
  }

  get isProcessedQuantityMissing(): boolean {
    return this.hasProductQuantity && (this.product.processedQuantity?.value ?? 0) < this.product.quantity.value;
  }

  get canDisplayOrderedQuantity(): boolean {
    return !this.isPrepared || !this.hasQuantityPrepared;
  }

  get canDisplayPreparedQuantity(): boolean {
    return this.isPrepared && this.hasQuantityPrepared;
  }

  get canDisplayMissingQuantity(): boolean {
    return this.isPrepared && this.hasQuantityPrepared && this.hasMissingQuantity;
  }
}
